export function isFiniteNumber( value: unknown ): value is number {
  return typeof value === 'number' && Number.isFinite( value );
}

export function formatScore( value: unknown ): string {
  return isFiniteNumber( value ) ? value.toFixed( 3 ) : '-';
}
